import { useEffect, useMemo, useRef } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Router as RouterType } from '@remix-run/router/dist/router';
import { SnackbarProvider } from 'notistack';
import { CssBaseline } from '@mui/material';

import { routes } from './router/routes';
import { authoritiesListSelector } from './store/selectors';
import { useAppSelector } from './utils/hooks';
import { useLazyGetMyAuthoritiesQuery } from './api/controllers/admin-roles';

export const App = () => {
  const router = useRef<RouterType | null>(null);
  router.current = createBrowserRouter(routes);

  const routerProvider = useMemo(() => {
    if (!router.current) {
      return <>Error</>;
    }

    if (router.current) {
      return <RouterProvider router={router.current} />;
    }

    return <>error</>;
  }, [router.current]);

  return (
    <SnackbarProvider maxSnack={3}>
      <CssBaseline />
      {routerProvider}
    </SnackbarProvider>
  );
};
